import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/about-breadcrumb.webp'
import { blogs } from "../Blog";
import { FaSearch } from "react-icons/fa";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import createBreadcrumbSchema from "../Schema/breadcrumbSchema";

const Blog=()=>{

 useEffect(() => {
        document.title =
          "Timber & Wooden Packaging Blog | Gurukrupa Wood Pvt. Ltd.";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Explore expert insights, material guides, and care tips for industrial wooden packaging, pallets, crates, and joinery from Gurukrupa Wood Pvt. Ltd."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://gurukrupawood.com/blog");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "Timber & Wooden Packaging Blog | Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Explore expert insights, material guides, and care tips for industrial wooden packaging, pallets, crates, and joinery from Gurukrupa Wood Pvt. Ltd."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://gurukrupawood.com/blog");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://gurukrupawood.com/about.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Timber & Wooden Packaging Blog | Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Explore expert insights, material guides, and care tips for industrial wooden packaging, pallets, crates, and joinery from Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://gurukrupawood.com/about.webp"
        );
      }
      }, []);

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
    },
  },
};

const buttonAnim = {
  hidden: {
    opacity: 0,
    scale: 0.9,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delay: 0.4,
      duration: 0.5,
    },
  },
};

const navigate = useNavigate();
const location = useLocation();

const [searchTerm, setSearchTerm] = useState("");
const [selectedCategory, setSelectedCategory] = useState("All");
const [appliedSearch, setAppliedSearch] = useState("");

const safeBlogs = Array.isArray(blogs) ? blogs : [];

const BLOGS_PER_PAGE = 6;

const handlePageChange = (newPage) => {
  setCurrentPage(newPage);

  navigate(`/blog?page=${newPage}`, {
    replace: true,
  });

  setTimeout(() => {
    const element = document.getElementById("blog-grid");

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 50);
};

const getPageFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const page = parseInt(params.get("page"), 10);

  return page && page > 0 ? page : 1;
};

const [currentPage, setCurrentPage] = useState(getPageFromUrl);

const categoriesList = ["All"];

safeBlogs.forEach((blog) => {
  if (
    blog?.category &&
    !categoriesList.includes(blog.category)
  ) {
    categoriesList.push(blog.category);
  }
});

useEffect(() => {
  if (location.state) {

    if (location.state.selectCategory) {

      setSelectedCategory(
        location.state.selectCategory
      );

      setSearchTerm("");
      setAppliedSearch("");

    } else if (location.state.searchString) {

      setAppliedSearch(
        location.state.searchString
      );

      setSearchTerm(
        location.state.searchString
      );

      setSelectedCategory("All");
    }

    setTimeout(() => {
      const section =
        document.getElementById("blog-grid");

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 100);

    window.history.replaceState(
      {},
      document.title
    );
  }
}, [location.state]);

const handleCategoryClick = (category) => {
  setSelectedCategory(category);
  setSearchTerm("");
  setAppliedSearch("");
};

const suggestions = [];

const cleanTerm =
  searchTerm.trim().toLowerCase();

if (cleanTerm !== "") {

  categoriesList.forEach((cat) => {

    if (
      cat !== "All" &&
      cat.toLowerCase().includes(cleanTerm)
    ) {
      suggestions.push({
        type: "category",
        value: cat,
      });
    }
  });

  safeBlogs.forEach((blog) => {

    if (
      blog?.title &&
      blog.title
        .toLowerCase()
        .includes(cleanTerm)
    ) {
      suggestions.push({
        type: "blog",
        value: blog.title,
        slug: blog.slug,
      });
    }
  });
}

const handleKeyDown = (e) => {

  if (e.key === "Enter") {

    if (suggestions.length > 0) {

      const topResult =
        suggestions[0];

      if (
        topResult.type === "category"
      ) {

        setSelectedCategory(
          topResult.value
        );

        setSearchTerm("");

        setAppliedSearch("");

      } else {

        navigate(
          `/blog/${topResult.slug}`
        );
      }

    } else {

      setAppliedSearch(searchTerm);
    }
  }
};

const filteredBlogs = blogs.filter(
  (blog) => {

    const matchesCategory =
      selectedCategory === "All" ||
      blog.category ===
        selectedCategory;

    const cleanAppliedSearch =
      appliedSearch
        .trim()
        .toLowerCase();

    const matchesSearch =
      cleanAppliedSearch === "" ||
      blog.title
        .toLowerCase()
        .includes(
          cleanAppliedSearch
        ) ||
      blog.category
        .toLowerCase()
        .includes(
          cleanAppliedSearch
        );

    return (
      matchesCategory &&
      matchesSearch
    );

  }
);

const totalPages = Math.ceil(
  filteredBlogs.length / BLOGS_PER_PAGE
);

// Make sure current page is never greater than total pages
const safeCurrentPage =
  totalPages > 0
    ? Math.min(currentPage, totalPages)
    : 1;

const startIndex =
  (safeCurrentPage - 1) * BLOGS_PER_PAGE;

const paginatedBlogs = filteredBlogs.slice(
  startIndex,
  startIndex + BLOGS_PER_PAGE
);

useEffect(() => {
    if (location.state) {
     if (location.state.selectCategory) {

  setSelectedCategory(location.state.selectCategory);
  setSearchTerm("");
  setAppliedSearch("");
  setCurrentPage(1);

} else if (location.state.searchString) {

  setAppliedSearch(location.state.searchString);
  setSearchTerm(location.state.searchString);
  setSelectedCategory("All");
  setCurrentPage(1);

}
      
      // Smoothly push view into focus right after updating state
      setTimeout(() => {
        const element = document.getElementById("blog-grid");
        if (element) {
          element.scrollIntoView();
        }
      }, 100);

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
  const page = getPageFromUrl();

  setCurrentPage(page);
}, [location.search]);


const breadcrumbSchema = createBreadcrumbSchema([
  {
    name: "Home",
    url: "https://gurukrupawood.com/"
  },
  {
    name: "Blog",
    url: "https://gurukrupawood.com/blog"
  },
]);
    return(
        <>

      <SchemaMarkup data={breadcrumbSchema} />

          <Breadcrumb
  pageName="Blogs"
  bgImage={bgImg}
/>

 {/**BLOG CARDS + SIDEBAR */}
       <section className="blog-listing-section">
  <div className="container">

    <div className="blog-layout">

      {/* LEFT */}
      <div className="blog-main"
       id="blog-grid">

        <motion.div
          className="blog-main-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >

          <p className="section-subheading">
            OUR BLOG
          </p>

          <h2 className="section-heading">
            Insights, Craftsmanship & Timber Care
          </h2>

        </motion.div>

     <div
  className={`blog-grid ${
    filteredBlogs.length === 0
      ? "blog-grid-empty"
      : ""
  }`}>

          {filteredBlogs.length === 0 ? (

  <div className="no-blog-found">

    <h3 className="card-heading">
      No Blogs Found
    </h3>

    <p className="section-text">
      No articles match your search.
    </p>

    <button
      className="quote-btn green-btn"
      onClick={() =>
        handleCategoryClick("All")
      }
    >
      Reset Filters
    </button>

  </div>

) : (

  paginatedBlogs.map((blog, index) => (

    <article
      key={index}
      className="products-card"
    >

      <div
        style={{
          overflow: "hidden",
        }}
      >
        <img
          src={blog.img}
          alt={`${blog.title} | Gurukrupa Wood Pvt. Ltd.`}
        />
      </div>

      <div className="product-card">

        <h3 className="card-heading">
          {blog.title}
        </h3>

        <p className="section-text">
          {blog.desc}
        </p>

         <motion.a
         href={`/blog/${blog.slug}`}
         className="product-card-link"
         whileHover="hover"
         initial="rest"
       >
       
         <motion.span
           className="know-more-text"
           variants={{
             rest: {
               opacity: 0,
               width: 0,
               marginRight: 0,
             },
             hover: {
               opacity: 1,
               width: "auto",
               marginRight: 4,
             },
           }}
           transition={{
             duration: 0.3,
           }}
         >
           Know More
         </motion.span>
       
         <motion.span
           className="arrow-icon"
           variants={{
             rest: {
               x: 0,
             },
             hover: {
               x: 8,
             },
           }}
           transition={{
             duration: 0.3,
           }}
         >
           →
         </motion.span>
       
       </motion.a>
      </div>

    </article>

  ))
)}
        </div>


{totalPages > 1 && (
  <div className="blog-pagination">

    <button
      className="pagination-btn"
      disabled={safeCurrentPage === 1}
      onClick={() =>
        handlePageChange(safeCurrentPage - 1)
      }
    >
      Previous
    </button>

    <span className="pagination-info">
      Page {safeCurrentPage} of {totalPages}
    </span>

    <button
      className="pagination-btn"
      disabled={safeCurrentPage === totalPages}
      onClick={() =>
        handlePageChange(safeCurrentPage + 1)
      }
    >
      Next
    </button>

  </div>
)}

      </div>

      {/* RIGHT */}
      <aside
        className="blog-sidebar"
      >

        {/* Search */}
        <motion.div
          className="blog-sidebar-box"
          variants={fadeUp}
        >

       <div className="blog-search">

  <input
    type="text"
    placeholder="Search Category / Articles"
    value={searchTerm}
    onChange={(e) =>
      setSearchTerm(e.target.value)
    }
    onKeyDown={handleKeyDown}
  />

  <FaSearch className="blog-search-icon" />

  {suggestions.length > 0 && (

    <div className="blog-search-dropdown">

      {suggestions.map(
        (item, idx) => (

          <div
            key={idx}
            className="blog-search-item"
            onClick={() => {

              if (
                item.type === "category"
              ) {

                handleCategoryClick(
                  item.value
                );

              } else {

                navigate(
                  `/blog/${item.slug}`
                );
              }
            }}
          >
            <span>
              {item.type === "category"
                ? "Category"
                : "Blog"}
            </span>

            {item.value}
          </div>
        )
      )}

    </div>

  )}

</div>

          <h3 className="card-heading">
            Categories
          </h3>

         <ul className="blog-categories">

  {categoriesList.map(
    (item, i) => (

      <li key={i}>

        <button
          className={`blog-category-btn ${
            selectedCategory === item
              ? "active"
              : ""
          }`}
          onClick={() =>
            handleCategoryClick(item)
          }
        >
          {item}
        </button>

      </li>
    )
  )}

</ul>
        </motion.div>

        {/* CTA */}
        <motion.div
          className="blog-sidebar-cta"
          initial={{
            opacity: 0,
            y: 50,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            duration: 0.8,
          }}
        >

          <h3 className="card-heading">
            Need Custom Wooden Packaging Solutions?
          </h3>

          <p className="section-text">
            Don't let inadequate packaging risk your heavy machinery or shipment safety. Get reliable, export-compliant pallets, crates, and plywood boxes tailored to your industrial needs.
          </p>

          <ul className="section-text">
            <li>✓ ISPM 15 Compliant & Heat Treated</li>
            <li>✓ Custom Sizes & Heavy-Duty Designs</li>
            <li>✓ Fast Turnaround & Competitive Pricing</li>
          </ul>

          <motion.a
            href="/products/customised-packaging"
            className="green-btn"
            variants={buttonAnim}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            whileHover={{
              scale: 1.05,
              y: -2,
            }}
            whileTap={{
              scale: 0.97,
            }}
          >
            Get a Quote
          </motion.a>

        </motion.div>

      </aside>

    </div>

  </div>
</section>

{/**CTA */}
<Cta />

        </>
    )
}
export default Blog;